/*
    Attach this directive directly to iterated menuFlow page with pageIdentifier property
    Will register menu flow page for scroll directive and inform about collapsing state.
    Collapse event is passed to menu-flow-pages service and then it's propagated and intercepted by
    consumers - modal-view component.
*/
import { Directive, Input, OnInit, OnChanges, SimpleChanges, OnDestroy, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

import { MenuFlowPagesService } from './menu-flow-pages.shared.service';

@Directive({
    selector: '[directive-menu-flow-page]',
})
export class MenuFlowPagesDirective implements OnInit, OnDestroy, OnChanges, AfterViewInit {
    private _elem: HTMLElement;
    private _init: boolean = false;

    @Input() public pageIdentifier: number;
    @Input() public isExpanded: boolean;

    constructor(
        private _menuFlowPagesService: MenuFlowPagesService,
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

        if (!this.pageIdentifier) {
            return console.warn(`[pageIdentifier] property not provided for [directive-menu-flow-page] in element: `, this._elem);
        }

        this._menuFlowPagesService.register(this.pageIdentifier, this._elem);

        if (!this._elem.id) {
            this._renderer2.setAttribute(this._elem, 'id', `menu-flow-page-identifier-${this.pageIdentifier}`); /* Will allow to use simpler solution without services */
        }
    }

    ngAfterViewInit(): void {
        this._init = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.pageIdentifier && this._init) {
            if (changes.isExpanded !== undefined) {
                //if (changes.isExpanded.previousValue !== undefined && changes.isExpanded.currentValue === false && changes.isExpanded.previousValue !== changes.isExpanded.currentValue) {
                /* Make sure emit value to item that has just expanded/collapsed */

                this._menuFlowPagesService.emitCollapse(this.pageIdentifier, this._elem);
                //}
            }
        }
    }

    ngOnDestroy(): void {
        if (!this.pageIdentifier) return;

        this._menuFlowPagesService.unregister(this.pageIdentifier);
    }
}
